import { Check } from 'lucide-react';
import type { ExamScope } from '../api/types';

export const ALL_SCOPES: readonly ExamScope[] = ['school', 'national', 'practice'] as const;
/** Readonly on purpose — copy it (`[...DEFAULT_SCOPES]`) before handing it to state or a payload. */
export const DEFAULT_SCOPES = ['school', 'national'] as const;

interface Props { value: ExamScope[]; onChange: (next: ExamScope[]) => void }

/** Exam scope as toggle pills with a check box (design `.pills` "Exam scope"). */
export function ScopeCheckboxes({ value, onChange }: Props) {
  function toggle(s: ExamScope) {
    onChange(value.includes(s) ? value.filter((x) => x !== s) : [...value, s]);
  }
  return (
    <div role="group" aria-label="Exam scope" className="flex flex-wrap items-center gap-1.5">
      {ALL_SCOPES.map((s) => {
        const on = value.includes(s);
        return (
          <button key={s} type="button" aria-pressed={on} aria-label={s} onClick={() => toggle(s)}
            className={`inline-flex min-h-[36px] items-center gap-1.5 rounded-full border px-3.5 text-[13px] font-medium transition-colors ${
              on
                ? 'border-navy bg-navy text-white dark:border-mist-fixed dark:bg-mist-fixed dark:text-navy'
                : 'border-line-strong bg-surface text-muted-2 hover:text-ink'}`}>
            <span aria-hidden className="inline-flex h-4 w-4 items-center justify-center rounded-[4px] border border-current">
              <Check size={11} strokeWidth={3} className={on ? 'opacity-100' : 'opacity-0'} />
            </span>
            <span className="capitalize">{s}</span>
          </button>
        );
      })}
    </div>
  );
}
